import * as back from '~/components/layouts/Navigation/BreadcrumbContainer/functional/backLinks';
import * as match from '~/components/layouts/Navigation/BreadcrumbContainer/functional/matchers';
import { getSettingsChildRouteMetadata, getSettingsRoutePath } from '~/config/settingsRouteMetadata';
import type { BreadcrumbContext, RouteRule } from '~/components/layouts/Navigation/BreadcrumbContainer/functional/types';

const PRIORITY = {
  HOME: 1000,
  ONBOARDING: 900,
  SETTINGS_CHILD: 450,
  SETTINGS: 350,
} as const;

const matchesSettingsChildRoute = (path: string) => !!getSettingsChildRouteMetadata(path);

const settingsChildBreadcrumb = (context: BreadcrumbContext) => {
  const matchedRoute = getSettingsChildRouteMetadata(context.path);

  if (!matchedRoute) {
    return [{ label: context.t('Settings') }];
  }

  return [
    { label: context.t('Settings'), link: '/settings' },
    { label: context.t(matchedRoute.labelKey), link: getSettingsRoutePath(matchedRoute.path) },
  ];
};

const settingsChildBackLink = (context: BreadcrumbContext) => (context.isMobile ? '/settings' : 'home');

export const coreRules: RouteRule[] = [
  {
    match: match.exact('/'),
    generate: (context) => [{ label: context.t('Home') }],
    backLink: back.home,
    priority: PRIORITY.HOME,
  },
  {
    match: match.startsWith('/onboarding'),
    generate: (context) => [{ label: context.t('Onboarding') }],
    backLink: back.homeLink,
    priority: PRIORITY.ONBOARDING,
  },
  {
    match: matchesSettingsChildRoute,
    generate: settingsChildBreadcrumb,
    backLink: settingsChildBackLink,
    priority: PRIORITY.SETTINGS_CHILD,
  },
  {
    match: match.startsWith('/settings'),
    generate: (context) => [{ label: context.t('Settings') }],
    backLink: back.homeLink,
    priority: PRIORITY.SETTINGS,
  },
];
